import { NotificationsWidget } from '@amzn/awscat-notification-ui-components';

import { getAuthToken } from '../../common/Authentication';

type NotificationsProps = {isAuthenticated: boolean};

function Notifications(props: NotificationsProps): JSX.Element | null {
    return props.isAuthenticated ? (
        <NotificationsWidget application='MPA' getJwtToken={getAuthToken}/>
    ) : null;
}

export default Notifications;
